/* eslint-disable react/no-danger */
import * as React from 'react';
import { IconChevronUp16 } from '@cian/ui-kit/icons';
import classNames from 'clsx';

import * as styles from './SeoMarkedListItem.css';

export interface ISeoMarkedListItemProps {
  id: string;
  title: string;
  content: string;
  expanded: boolean;
}

export const SeoMarkedListItem: React.VFC<ISeoMarkedListItemProps> = ({ id, title, content, expanded }) => {
  const [isExpanded, setExpanded] = React.useState<boolean>(expanded);
  const headingId = `${id}_heading`;
  const bodyId = `${id}_body`;

  const toggleExpanded = React.useCallback(() => setExpanded(prev => !prev), []);

  return (
    <div className={classNames(styles['container'], !isExpanded && styles['closed'])} data-testid="SeoMarkedListItem">
      {title && (
        <div
          id={headingId}
          role="button"
          aria-expanded={isExpanded}
          aria-controls={bodyId}
          tabIndex={0}
          className={styles['heading']}
          onClick={toggleExpanded}
        >
          <div className={styles['title']} dangerouslySetInnerHTML={{ __html: title }} />
          <div className={styles['arrow-wrapper']}>
            <IconChevronUp16 />
          </div>
        </div>
      )}
      <div
        id={bodyId}
        aria-describedby={title ? headingId : undefined}
        className={styles['content']}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
};
